import React, { FC } from 'react'

import { IconBundlesProps } from './IconBundles.types'
import * as Styled from './styles/IconBundles.style'

import { nonThemeableRules } from '../../ruleSet'

const IconBundles: FC<IconBundlesProps> = ({
  size = nonThemeableRules.defaultSize as number as IconBundlesProps['size'],
  isResponsive = false,
}: IconBundlesProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M24.1 25.7v15.325M9.073 27.5v4.64a3.515 3.515 0 0 0 2.014 3.18L22.5 40.713a3.501 3.501 0 0 0 3 0l11.4-5.4a3.517 3.517 0 0 0 2.013-3.18V27.42'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='m9.072 18.64-2.955 4.43a2.205 2.205 0 0 0 .89 3.207l10.928 5.16a2.212 2.212 0 0 0 2.773-.777l3.39-4.973L9.072 18.64Zm21.03 12.795L41 26.29a2.2 2.2 0 0 0 1.047-2.93 2.086 2.086 0 0 0-.157-.282l-2.965-4.43-14.83 7.047 3.233 4.975a2.215 2.215 0 0 0 2.774.765ZM9.07 18.635l15.18-7.158-2.652-2.532a4.135 4.135 0 0 0-4.638-.763L7.985 12.41a2.593 2.593 0 0 0-.838 4.063l1.92 2.162h.003Z'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='m38.935 18.635 2-2.208a2.583 2.583 0 0 0-.785-4.07l-8.547-4.15a4.143 4.143 0 0 0-4.643.706l-2.725 2.56 14.7 7.162Z'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconBundles
